<template>
  <div class="permissions-view">
    <div class="row permissions-container">
      <div class="col-12">
        <div class="d-flex align-items-center justify-content-between">
          <back-arrow :title="$t('Autorisations')"/>
        </div>
      </div>

      <div class="col-12 mt-2 permission-item">
        <b-alert class="mt-2" variant="danger" show  v-if="showAlert" v-on:close="closeAlert()">
          {{$t('autorisation.Denied')}}
        </b-alert>
        <div class="d-flex align-items-center permission-toggle">
          <label for="pushNotifications" class="permission-label mr-3">{{$t('autorisation.notification.title')}}</label>
          <b-form-checkbox
            size="lg"
            id="pushNotifications"
            :checked="permissions.pushNotifications"
            @change="toggleNotificationPermission"
            switch
          ></b-form-checkbox>
        </div>
        <p class="card p-3 description">{{$t('autorisation.notification.text')}}</p>
        <div class="param-notif mb-2 cursor-pointer" @click="openParamModal()" >
          <div>{{$t('autorisation.Params')}}</div>
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M14.1922 10.4422L7.94219 16.6922C7.85478 16.7797 7.74337 16.8393 7.62207 16.8635C7.50076 16.8876 7.37502 16.8752 7.26076 16.8279C7.14649 16.7805 7.04884 16.7004 6.98017 16.5975C6.91151 16.4946 6.8749 16.3737 6.875 16.25V3.75C6.8749 3.62632 6.91151 3.50539 6.98017 3.40252C7.04884 3.29964 7.14649 3.21946 7.26076 3.17211C7.37502 3.12477 7.50076 3.11239 7.62207 3.13655C7.74337 3.1607 7.85478 3.22031 7.94219 3.30782L14.1922 9.55782C14.2503 9.61586 14.2964 9.68479 14.3279 9.76067C14.3593 9.83654 14.3755 9.91787 14.3755 10C14.3755 10.0821 14.3593 10.1635 14.3279 10.2393C14.2964 10.3152 14.2503 10.3841 14.1922 10.4422Z" fill="#EAEAEA"/>
            </svg>
          </div>
        </div>
      </div>

      <div class="col-12 mt-2 permission-item">
        <div class="d-flex align-items-center permission-toggle">
          <label for="geoloc" class="permission-label mr-3">{{$t('autorisation.geolocations.title')}}</label>
          <b-form-checkbox
            size="lg"
            id="geoloc"
            :checked="permissions.geolocations"
            @change="toggleGeolocationPermission"
            switch
          ></b-form-checkbox>
        </div>
        <p class="card p-3 description">{{$t('autorisation.geolocations.text')}}</p>
      </div>

      <div class="col-12 mt-2 permission-item">
        <div class="d-flex align-items-center permission-toggle">
          <label for="cameraAccess" class="permission-label mr-3">{{$t('autorisation.camera.title')}}</label>
          <b-form-checkbox
            size="lg"
            id="cameraAccess"
            :checked="permissions.cameraAccess"
            @change="toggleCameraPermission"
            switch
          ></b-form-checkbox>
        </div>
        <p class="card p-3 description">{{$t('autorisation.camera.text')}}</p>
      </div>
    </div>
    <notif-param-modal></notif-param-modal>
  </div>
</template>

<script>
import BackArrow from "../../components/b122/BackArrow";
import NotifParamModal from "../user/NotifParamModal";

export default {
  name: "Autorisations",
  components: {
    BackArrow,
    NotifParamModal
  },
  data() {
    return {
      permissions: {
        pushNotifications: null,
        geolocations: null,
        cameraAccess: null,
        fileAccess: null,
      },
      showAlert: false,
      alertTimeout: null,
    };
  },
  mounted() {
    this.checkNotificationPermission();
    this.checkGeolocationPermission();
    this.checkCameraPermission();
  },
  methods: {
    checkNotificationPermission() {
      if (!("Notification" in window)) {
        return;
      }
      if (Notification.permission === "granted") {
        this.permissions.pushNotifications = true;
      } else if (Notification.permission === "denied") {
        this.permissions.pushNotifications = false;
      }
    },

    checkGeolocationPermission() {
      navigator.permissions.query({ name: 'geolocation' }).then(permission => {
        if (permission.state === 'granted') {
          this.permissions.geolocations = true;
        } else if (permission.state === 'denied') {
          this.permissions.geolocations = false;
        }
      });
    },

    checkCameraPermission() {
      navigator.permissions.query({ name: 'camera' }).then(permission => {
        if (permission.state === 'granted') {
          this.permissions.cameraAccess = true;
        } else if (permission.state === 'denied') {
          this.permissions.cameraAccess = false;
        }
      });
    },
    toggleNotificationPermission() {
      if (this.permissions.pushNotifications !== null) {
        this.showPermissionAlert();
      }
      if (this.permissions.pushNotifications) {

      } else {
        Notification.requestPermission().then(permission => {
          this.permissions.pushNotifications = permission === 'granted';
        });
      }
    },
    toggleGeolocationPermission() {
      if (this.permissions.geolocations !== null) {
        this.showPermissionAlert();
      }
      if (this.permissions.geolocations) {

      } else {
        navigator.geolocation.getCurrentPosition(() => {
          this.permissions.geolocations = true;
        }, () => {
          this.permissions.geolocations = false;
        });
      }
    },
    toggleCameraPermission() {
      if (this.permissions.cameraAccess !== null) {
        this.showPermissionAlert();
        return
      }
      navigator.mediaDevices.getUserMedia({ video: true })
        .then(stream => {
          this.permissions.cameraAccess = true;
          stream.getTracks().forEach(track => track.stop());
        })
        .catch(error => {
          this.permissions.cameraAccess = false;
        });
    },
    toggleFilePermission() {
      let fileInput = document.createElement('input');
      fileInput.type = 'file';
      fileInput.onchange = () => {
        this.permissions.fileAccess = true;
      };
      fileInput.click();
    },
    showPermissionAlert() {
      this.showAlert = true;
      clearTimeout(this.alertTimeout);
      this.alertTimeout = setTimeout(() => {
        this.showAlert = false;
      }, 20000);
    },
    closeAlert() {
      this.showAlert = false;
      clearTimeout(this.alertTimeout);
    },

    openParamModal(){
      this.$bvModal.show('notif-param-modal')
    }
  },
};
</script>

<style scoped>
.permissions-view {
  padding: 20px;
}

.permission-toggle {
  display: flex;
  align-items: center;
}

.permission-label {
  white-space: nowrap;
  margin-right: 1rem;
}

.description {
  font-size: 0.875rem;
  color: #6c757d;
  margin-top: 0.5rem;
}



label {
  margin-bottom: 0!important;
}

.param-notif{
  display: flex;
  justify-content: space-between;
  padding-bottom: 1em;
  border-bottom: 1px solid var(--main-grey-dark);
}

.alert-danger {
  background-color: var(--main-black-dark)!important;
  border-color: var(--main-red-medium)!important;
  font-size: 0.875rem!important;
  color: #6c757d!important;
  margin-top: 0.5rem!important;
  border-radius: var(--main-border-radius);
}



</style>



// WEBPACK FOOTER //
// src/views/autorisations/Autorisations.vue